module.exports = __webpack_public_path__ + "img/gift1.81bb52ce.jpg";